import {
  WeatherMapPlaybackButton,
  WeatherMapPlaybackSpeedControl,
} from '../../../../components/WeatherMapPlayback/WeatherMapPlayback';
import { Form } from 'react-bootstrap';
import { HURRICANES_REPLAY_SPEED_OPTIONS } from '../../../../features/Hurricanes/config/hurricanes.config';

// Compact single-row replay player used by the dashboard widget. Hidden when
// the selected storm has no replayable track; the full-page view uses the
// richer StormReplayPanel instead.
const StormReplayBar = ({ storm, replay, showSpeeds = false, showTimestamp = true }) => {
  const {
    frameIndex,
    lastFrameIndex,
    isPlaying,
    replaySpeed,
    setReplaySpeed,
    togglePlayback,
    scrubToFrame,
  } = replay;

  const records = storm?.records ?? [];
  if (records.length < 2) return null;

  const activeRecord = records[Math.min(frameIndex, records.length - 1)];

  return (
    <div
      className="hurricanes-replay-bar d-flex align-items-center gap-2 flex-shrink-0 min-w-0"
      role="group"
      aria-label="Storm replay"
    >
      <WeatherMapPlaybackButton
        isPlaying={isPlaying}
        onToggle={togglePlayback}
        playLabel="Play storm replay"
        pauseLabel="Pause storm replay"
      />
      <Form.Range
        className="flex-grow-1"
        min={0}
        max={lastFrameIndex}
        step={1}
        value={frameIndex}
        onChange={(event) => scrubToFrame(event.target.value)}
        aria-label="Scrub storm track timeline"
        aria-valuetext={activeRecord?.locale_time}
      />
      {showSpeeds && (
        <WeatherMapPlaybackSpeedControl
          speeds={HURRICANES_REPLAY_SPEED_OPTIONS}
          value={replaySpeed}
          onChange={setReplaySpeed}
          ariaLabel="Replay speed"
          className="flex-nowrap flex-shrink-0"
          buttonClassName="hurricanes-replay-speed px-1 py-0"
        />
      )}
      {showTimestamp && (
        <span className="hurricanes-replay-timestamp small text-secondary text-nowrap flex-shrink-0">
          {activeRecord?.locale_time}
        </span>
      )}
    </div>
  );
};

export default StormReplayBar;
